export const personasContent = `
Personas simulate different stakeholder perspectives when reviewing your requirements. They help surface concerns that might be missed by a single viewpoint.

{% card title="Built-in Personas" %}
Reqqy includes pre-configured personas representing common stakeholder roles:

- **Senior Engineer** — Focuses on technical feasibility and edge cases
- **QA Lead** — Evaluates testability and acceptance criteria
- **Product Manager** — Assesses business value and user impact
- **UX Designer** — Reviews usability and interaction clarity
{% /card %}

{% card title="Custom Personas" %}
Create your own personas with specific roles, goals, and constraints. Custom personas can be private, shared with your project team, or across your entire organisation. You can also grant individual users viewer or editor permissions for fine-grained access control.
{% /card %}
`;
